import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Switch, useLocation } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Preloader from './components/Preloader';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './components/Home/Home';
import About from './components/About/About';
import Projects from './components/Projects/Projects';
import Resume from './components/Resume/Resume';
import NotFound from './components/NotFound';

function Content(props) {
	let location = useLocation();

	return (
		<TransitionGroup>
			<CSSTransition key={location.key} timeout={300} classNames='fade'>
				<Switch location={location}>
					<Route path='/' exact><Home language={props.language} /></Route>
					<Route path='/about'><About language={props.language} /></Route>
					<Route path='/projects'><Projects language={props.language} /></Route>
					<Route path='/resume'><Resume language={props.language} /></Route>
					<Route path='*'><NotFound language={props.language} /></Route>
				</Switch>
			</CSSTransition>
		</TransitionGroup>
	);
}

function App() {
	const [load, setLoad] = useState(true);
	const [language, setLanguage] = useState('english');

	useEffect(() => {
		setTimeout(() => {
			let lang = localStorage.getItem('language');
			localStorage.clear();
			if (lang !== null && lang !== '') {
				setLanguage(lang);
			}
			setLoad(false);
		}, 800);
	}, []);

	return (
		<Router>
			<div className='fill'>
				<Preloader load={load} />
				<div className='App' id={load ? 'no-scroll' : 'scroll'}>
					<Navbar language={language} setLanguage={setLanguage} />
					<ScrollToTop />
					<Content language={language} />
					<Footer language={language} />
				</div>
			</div>
		</Router>
	);
}

export default App;
